import $ from 'jquery';
import selectric from 'selectric';
import LazyLoad from 'vanilla-lazyload';

class Selectric {
    constructor(el, settings) {
        this.select = $(el);
        this.settings = settings;
        this.init();
    }

    init() {
        if (this.select.length) {

            var lazyImg = new LazyLoad({
                    elements_selector: '.swiper-slider img'
                }),

                defaultSettings = {
                    onClose: function() {
                        lazyImg.loadAll();
                        lazyImg.update();
                    }
                },
                getSettings = this.settings,
                fullSettings = Object.assign(getSettings, defaultSettings);

            this.select.selectric(fullSettings);
        }
    }

}

export default Selectric;